import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const links = [
  { to: '/weddings', label: 'Weddings' },
  { to: '/quinceaneras', label: 'Quinceañeras' },
  { to: '/events', label: 'Events' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/about', label: 'About' },
];

const Nav = ({ transparent = false }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = !transparent || scrolled;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid ? 'bg-ivory/95 backdrop-blur-md shadow-sm border-b border-gold/20' : 'bg-transparent'
      }`}
      data-testid="site-nav"
    >
      <nav className="container mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="font-serif text-2xl font-bold tracking-wide">
          <span className={solid ? 'text-navy' : 'text-white'}>Queensland</span>{' '}
          <span className="text-gold">Ranch</span>
        </Link>

        <div className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`text-sm tracking-wide font-medium transition-colors ${
                pathname === l.to
                  ? 'text-gold'
                  : solid ? 'text-navy hover:text-gold' : 'text-white/90 hover:text-gold'
              }`}
              data-testid={`nav-${l.label.toLowerCase()}`}
            >
              {l.label}
            </Link>
          ))}
          <Link to="/contact">
            <Button
              className="bg-navy hover:bg-navy/90 text-gold border border-gold/60 tracking-wide"
              data-testid="nav-cta"
            >
              Check Availability
            </Button>
          </Link>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden ${solid ? 'text-navy' : 'text-white'}`}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="lg:hidden bg-ivory border-t border-gold/20 shadow-lg" data-testid="nav-mobile-menu">
          <div className="container mx-auto px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-navy hover:text-gold font-medium py-1"
              >
                {l.label}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setOpen(false)}>
              <Button className="bg-navy text-gold border border-gold/60 w-full mt-2">
                Check Availability
              </Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
